import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=36f78a2e&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=36f78a2e&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f78a2e')) {
      api.createRecord('36f78a2e', component.options)
    } else {
      api.reload('36f78a2e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=36f78a2e&", function () {
      api.rerender('36f78a2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/attendances/edit.vue"
export default component.exports